module.exports = __webpack_public_path__ + "img/pov-api.ebe3b415.png";